import AutoCodesModal from './AutoCodesModal';
import LocationSelectModal from './LocationSelectModal';
import ReceivedPOMergeModal from './ReceivedPOMergeModal';
import ReceivedPOSplitModal from './ReceivedPOSplitModal';
const warehouseManagement = {
  AutoCodesModal,
  LocationSelectModal,
  ReceivedPOMergeModal,
  ReceivedPOSplitModal,
}

export default warehouseManagement;


// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/warehouseManagement/index.jsx